import { Row } from 'antd'
import { KStepsProps } from 'app/components/Modules/Navigation/typing'
import KCol from 'app/components/UI-Elements/Layout/KCol'
import Steps from 'app/components/UI-Elements/Navigation/Steps'
import { ComponentProps } from 'react'
import * as React from 'react'
import { useIntl } from 'react-intl'

const KSteps: React.FC<KStepsProps & Partial<ComponentProps<typeof Steps>>> = ({
  recordType,
  stepsCount,
  elements,
  current,
  stepTitleClassName,
  onlyHeader,
  ...others
}) => {
  const { formatMessage } = useIntl()

  const getStepTitle = (index: number) => {
    return (
      <span className={stepTitleClassName}>
        {formatMessage({ id: `component.navigation.steps.step.${recordType}.${index}` })}
      </span>
    )
  }

  const getSteps = () =>
    (elements || new Array(stepsCount).fill('')).map((_, index) => ({
      key: `kstep-${index}`,
      title: getStepTitle(index)
    }))

  return (
    <Row gutter={[0, 24]}>
      <KCol span={24}>
        <Steps steps={getSteps()} current={current} {...others} />
      </KCol>
      <If condition={!onlyHeader}>
        <KCol span={24}>{elements[current]}</KCol>
      </If>
    </Row>
  )
}

export default KSteps
